
import firebase from 'firebase/app';
import 'firebase/firestore';


function ShareReceive(props){

    console.log("handling share receive!")
    
    const docId = props.match.params.id;
    const userId = firebase.auth().currentUser.uid;
    const db = firebase.firestore();

    const docData = {
        shareTo: userId,
        receiveTime: firebase.firestore.FieldValue.serverTimestamp(),        
    }

    db.collection("sharereceive").doc(docId).set(docData)
        .then(function() {
            console.log("Document successfully written!");
        })
        .catch(function(error) {
            console.error("Error writing document: ", error);
        });

    props.history.push("/");
    return null;

}

export default ShareReceive;


// WEBPACK FOOTER //
// ./src/components/ShareReceive.js